import React from 'react'
import { ShareContentContainer, HoverableShareIconWrapper, NonHoverableShareIconWrapper } from './styles'
import { Typography } from 'react-components'
import { useTranslation } from '../../../../hooks/locale'
import { StyledGhostButton, CTAButton } from '../../styles'
import {
    MailPickerIcon,
    WhatsAppIcon,
    FaceBookIcon,
    MessengerIcon,
    CopyLinkIcon,
} from '../../../search-result-listing/header-section/searchbar/widget-styles'

const ShareIcons: { [key: string]: React.JSX.Element } = {
    shareMail: <MailPickerIcon />,
    shareWhatsapp: <WhatsAppIcon />,
    shareFacebook: <FaceBookIcon />,
    shareMessenger: <MessengerIcon />,
    shareLink: <CopyLinkIcon />,
}

const handleShareButtonClick = async ({ url, key, onClose }: { url: string; key: string; onClose: () => void }) => {
    onClose()
    if (key === 'page_url') {
        try {
            await navigator.clipboard.writeText(url)
        } catch (error) {
            console.error('Failed to copy the link:', error)
        }
        return
    }
    if (url.startsWith('mailto:') || url.startsWith('whatsapp:')) {
        globalThis.location.href = url
        return
    } else {
        window.open(url, '_blank', 'noopener,noreferrer')
        return
    }
}

const SharePopoverContent = ({
    shareLinks,
    onClose,
}: {
    shareLinks: { [key: string]: { url: string; translationKey: string; iconKey: string } }
    onClose: () => void
}) => {
    const { t } = useTranslation()
    const hoverableIcons = new Set(['shareMail', 'shareLink'])

    return (
        <ShareContentContainer>
            {Object.entries(shareLinks).map(([key, value]) => {
                const iconElement = ShareIcons[value.iconKey]
                const isHoverable = hoverableIcons.has(value.iconKey)
                const Wrapper = isHoverable ? HoverableShareIconWrapper : NonHoverableShareIconWrapper
                return (
                    <CTAButton
                        key={key}
                        onClick={async () => {
                            await handleShareButtonClick({ url: value.url, key, onClose })
                        }}
                    >
                        <StyledGhostButton isPrimary={false} isContentWidth={false}>
                            <Wrapper>{React.cloneElement(iconElement, { style: { position: 'unset' } })}</Wrapper>
                            <Typography variant="subtitle2" fontWeight="regular">
                                {t(value.translationKey)}
                            </Typography>
                        </StyledGhostButton>
                    </CTAButton>
                )
            })}
        </ShareContentContainer>
    )
}

export default SharePopoverContent
